import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/lib/data";

const CONTENT = {
  privacidade: {
    eyebrow: "Legal",
    title: "Política de Privacidade",
    updated: "Última atualização: junho de 2026",
    sections: [
      {
        h: "1. Responsável pelo tratamento",
        p: `A Get Visible é responsável pelo tratamento dos dados pessoais recolhidos através deste website. Para qualquer questão, contacte-nos através de ${CONTACT.email} ou ${CONTACT.phone}.`,
      },
      {
        h: "2. Dados que recolhemos",
        p: "Recolhemos apenas os dados que nos fornece voluntariamente através do formulário de contacto: nome, endereço de email e o conteúdo da mensagem. Não recolhemos dados sensíveis.",
      },
      {
        h: "3. Finalidade e base legal",
        p: "Os dados são utilizados exclusivamente para responder ao seu pedido e gerir a nossa relação comercial. A base legal é o seu consentimento (RGPD, art. 6.º/1/a), dado no momento do envio do formulário.",
      },
      {
        h: "4. Conservação",
        p: "Conservamos os seus dados apenas pelo período necessário para dar resposta ao seu pedido e cumprir obrigações legais. Findo esse período, os dados são eliminados de forma segura.",
      },
      {
        h: "5. Os seus direitos",
        p: "Tem direito de aceder, retificar, apagar, limitar ou opor-se ao tratamento dos seus dados, bem como à portabilidade. Pode exercer estes direitos contactando-nos. Tem ainda o direito de apresentar reclamação à CNPD.",
      },
      {
        h: "6. Segurança",
        p: "Adotamos medidas técnicas e organizativas adequadas para proteger os seus dados contra acesso não autorizado, perda ou destruição.",
      },
    ],
  },
  cookies: {
    eyebrow: "Legal",
    title: "Política de Cookies",
    updated: "Última atualização: junho de 2026",
    sections: [
      {
        h: "1. O que são cookies",
        p: "Cookies são pequenos ficheiros de texto guardados no seu dispositivo quando visita um website, que permitem melhorar a experiência de navegação.",
      },
      {
        h: "2. Cookies que utilizamos",
        p: "Este website utiliza apenas cookies estritamente necessários ao seu funcionamento. Não utilizamos cookies de publicidade nem partilhamos dados com terceiros para fins de marketing.",
      },
      {
        h: "3. Cookies analíticos",
        p: "Poderemos, futuramente e com o seu consentimento, utilizar cookies analíticos para compreender como os visitantes utilizam o site e melhorar os nossos serviços.",
      },
      {
        h: "4. Gestão de cookies",
        p: "Pode configurar o seu navegador para recusar ou eliminar cookies. Note que a desativação de alguns cookies pode afetar o funcionamento do website.",
      },
      {
        h: "5. Contacto",
        p: `Para questões sobre esta política, contacte-nos através de ${CONTACT.email}.`,
      },
    ],
  },
};

export default function Legal({ kind = "privacidade" }) {
  const data = CONTENT[kind] || CONTENT.privacidade;
  return (
    <section className="mx-auto max-w-3xl px-6 pb-24 pt-36 md:px-12 md:pb-32 md:pt-44">
      <Reveal>
        <p className="mb-4 text-xs uppercase tracking-[0.28em] text-regatta">{data.eyebrow}</p>
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-charcoal sm:text-5xl">{data.title}</h1>
        <p className="mt-4 text-sm text-charcoal/50">{data.updated}</p>
      </Reveal>

      <div className="mt-12 flex flex-col gap-10">
        {data.sections.map((s, i) => (
          <Reveal key={s.h} delay={Math.min(i, 3)}>
            <h2 className="font-display text-xl font-medium text-charcoal">{s.h}</h2>
            <p className="mt-3 leading-relaxed text-charcoal/70">{s.p}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
